<div class="background">
  <div class="activationContainer">
    <div class="activationContainerBox">
      <h1>Sehr gut! Das Konto wurde aktiviert!</h1>
      <p class="">
        Zum <a routerLink="/login">Login</a>
      </p>
    </div>
  </div>
</div>
